import { mutationRequest } from "@util/request"
import { api_v1_referral_conversions_path, api_v1_referrals_path } from "../routes"

export interface ReferralParams {
  post_id?:          string | number
  source:            string
  section?:          string | null
  campaign?:         string | null
  referrer_user_id?: string | null
  anonymous_token:   string
}

export interface ReferralConversionParams {
  convertible_type: string
  convertible_id:   string | number
  conversion_type:  string
}

export async function createReferral(params: ReferralParams): Promise<void> {
  await mutationRequest({
    path:    api_v1_referrals_path(),
    options: { method: "POST" },
    data:    params,
  })
}

export async function createReferralConversion(params: ReferralConversionParams): Promise<void> {
  await mutationRequest({
    path:    api_v1_referral_conversions_path(),
    options: { method: "POST" },
    data:    params,
  })
}
